import { useCallback, useRef } from 'react'

interface AbortSignalResult {
  abort: () => void
  controllerRef: React.RefObject<AbortController>
}

export function useAbortSignal(): AbortSignalResult {
  const controllerRef = useRef(new AbortController())

  const abort = useCallback(() => {
    controllerRef.current.abort()
    controllerRef.current = new AbortController()
  }, [])

  return {
    abort,
    controllerRef,
  }
}
